(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tes-art-direction"] && !Shopify.designMode) return;
  try {
    (() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const pointer = matchMedia('(hover: hover) and (pointer: fine)');
  const mounted = new WeakSet();
  const visibility = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target,isIntersecting}) => {target.dataset.visible = String(isIntersecting && !reduced.matches && !document.hidden);});
  },{threshold:.12}) : null;
  function init(root=document) {
    root.querySelectorAll('.tes-product-copy:not([data-art-formatted])').forEach(copy=>{
      copy.dataset.artFormatted='true';
      copy.querySelectorAll('p').forEach(paragraph=>{
        const nodes=Array.from(paragraph.childNodes);
        if(!nodes.some(node=>node.nodeType===1 && node.tagName==='BR') ||
          paragraph.querySelector('img,iframe,video,table,input,button')) return;
        const lines=[[]];
        nodes.forEach(node=>{
          if(node.nodeType===1 && node.tagName==='BR') lines.push([]);
          else lines[lines.length-1].push(node);
        });
        const meaningful=lines.filter(line=>line.some(node=>node.textContent.trim()));
        if(meaningful.length<3 && !meaningful.every(line=>line.find(node=>node.nodeType===1)?.tagName==='STRONG' && /[:：]$/.test(line.find(node=>node.nodeType===1).textContent.trim()))) return;
        if(meaningful.length<2 || meaningful.some(line=>line.map(node=>node.textContent).join('').trim().length>160)) return;
        meaningful.forEach((line,index)=>{
          const item=paragraph.cloneNode(false);
          if(index) item.removeAttribute('id');
          item.dataset.tesCopyLine='true';
          line.forEach(node=>item.append(node));
          paragraph.before(item);
        });
        paragraph.remove();
      });
      copy.querySelectorAll('ul').forEach(list=>{
        if(list.querySelector('ul,ol,img,iframe,video,table') || list.children.length<2) return;
        if(Array.from(list.children).some(item=>item.tagName!=='LI')) return;
        list.classList.add('tes-copy-points');
        list.setAttribute('role','list');
      });
      copy.querySelectorAll('table').forEach(table=>{
        if(table.querySelector('table,thead') || table.querySelectorAll('tbody').length!==1) return;
        const rows=Array.from(table.querySelectorAll('tr'));
        if(rows.length<2 || rows.some(row=>row.children.length!==2 || Array.from(row.children).some(cell=>cell.hasAttribute('colspan') || cell.hasAttribute('rowspan')))) return;
        table.classList.add('tes-spec-table');table.setAttribute('role','table');
        table.querySelector('tbody').setAttribute('role','rowgroup');
        rows.forEach(row=>{
          row.setAttribute('role','row');
          Array.from(row.children).forEach((cell,index)=>cell.setAttribute('role',index===0?'rowheader':'cell'));
        });
      });
      let section;
      Array.from(copy.childNodes).forEach(node=>{
        if(node.nodeType===1 && node.tagName==='H2'){
          section=document.createElement('section');section.className='tes-copy-section';
          copy.insertBefore(section,node);section.append(node);
        }else if(section){section.append(node);}
      });
      [copy,...copy.querySelectorAll('.tes-copy-section')].forEach(group=>{
        const paragraphs=Array.from(group.children).filter(child=>child.tagName==='P' && child.textContent.trim());
        const other=Array.from(group.children).filter(child=>!['P','H2','HR'].includes(child.tagName));
        if(paragraphs.length<(paragraphs.some(p=>p.dataset.tesCopyLine)?2:4) || other.length || paragraphs.some(p=>p.textContent.trim().length>160 || p.querySelector('img,iframe,video'))) return;
        const facts=paragraphs.filter(p=>p.firstElementChild?.tagName==='STRONG' && /[:：]$/.test(p.firstElementChild.textContent.trim()));
        const grid=document.createElement('div');grid.className=facts.length===paragraphs.length ? 'tes-copy-facts' : 'tes-copy-points';
        if(facts.length===paragraphs.length) facts.forEach(p=>{const label=p.firstElementChild;const value=document.createElement('bdi');value.dir='auto';Array.from(p.childNodes).filter(node=>node!==label).forEach(node=>value.append(node));p.append(value);});
        paragraphs[0].before(grid);paragraphs.forEach(p=>grid.append(p));
      });
    });
    root.querySelectorAll('[data-tes-world]').forEach(world => {
      if(mounted.has(world)) return;
      mounted.add(world);
      world.dataset.visible='false';
      if(visibility) visibility.observe(world);
      const pause=world.querySelector('.tes-world-pause');
      const label=pause.querySelector('[data-pause-label]');
      const status=world.querySelector('[data-world-status]');
      world.querySelectorAll('[data-world-mode]').forEach(button => button.addEventListener('click',()=>{
        const mode=button.dataset.worldMode;
        world.dataset.mode=mode;
        world.querySelectorAll('[data-world-mode]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
        status.textContent=status.dataset[mode];
      }));
      pause.addEventListener('click',()=>{
        const paused=world.classList.toggle('is-paused');
        pause.setAttribute('aria-pressed',String(paused));
        label.textContent=paused ? pause.dataset.play : pause.dataset.pause;
        pause.querySelector('[data-pause-glyph]').setAttribute('d', paused ? 'M3 1l8 5-8 5z' : 'M2 1h3v10H2zM7 1h3v10H7z');
        if(paused) reset();
      });
      const stage=world.querySelector('.tes-world-perspective');
      let frame=0;
      function reset(){cancelAnimationFrame(frame);frame=0;stage.style.removeProperty('--world-x');stage.style.removeProperty('--world-y');}
      stage.addEventListener('pointermove',event=>{
        if(!pointer.matches || reduced.matches || world.classList.contains('is-paused')) return;
        const rect=stage.getBoundingClientRect();
        const x=Math.max(-1,Math.min(1,(event.clientX-rect.left)/rect.width*2-1));
        const y=Math.max(-1,Math.min(1,(event.clientY-rect.top)/rect.height*2-1));
        cancelAnimationFrame(frame);
        frame=requestAnimationFrame(()=>{stage.style.setProperty('--world-x',(-y*4).toFixed(2)+'deg');stage.style.setProperty('--world-y',(x*5).toFixed(2)+'deg');frame=0;});
      },{passive:true});
      stage.addEventListener('pointerleave',reset);
      reduced.addEventListener('change',()=>{reset();world.dataset.visible='false';if(visibility){visibility.unobserve(world);visibility.observe(world);}});
    });
    root.querySelectorAll('.tes-catalog-intro nav a').forEach(link=>{
      if(new URL(link.href).pathname.replace(/\/$/,'')===location.pathname.replace(/\/$/,'')) link.setAttribute('aria-current','page');
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('visibilitychange',()=>document.querySelectorAll('[data-tes-world]').forEach(world=>{
    world.dataset.visible='false';if(!document.hidden && visibility){visibility.unobserve(world);visibility.observe(world);}
  }));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tes-motion-design"] && !Shopify.designMode) return;
  try {
    (() => {
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  let observer;
  const init = () => {
    document.querySelectorAll('.tes-product-story').forEach(story=>{
      const nav=story.querySelector('.tes-detail-jumps');
      if(!nav || nav.children.length) return;
      story.querySelectorAll('.tes-product-copy h2').forEach((heading,index)=>{
        if(index>7 || !heading.textContent.trim()) return;
        if(!heading.id) heading.id='tes-detail-'+index;
        const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent.trim();nav.append(link);
      });
      nav.hidden=nav.children.length<2;
    });
    if (!('IntersectionObserver' in window)) return;
    if (!observer) observer = new IntersectionObserver(entries => entries.forEach(entry => {
      const item = entry.target;
      if (item.matches('[data-tes-motion]')) item.classList.toggle('is-in-view', entry.isIntersecting && !preference.matches);
      else if (entry.isIntersecting) { if (!preference.matches) item.classList.add('tes-motion-ready'); observer.unobserve(item); }
    }), {threshold: .15});
    document.querySelectorAll('[data-tes-motion],.tes-feature-card,.tes-case-card,.tes-product-story header,.tes-product-assurance,.tes-customer-intro,.tes-buying-guide article').forEach(item => {
      if (seen.has(item)) return; seen.add(item); observer.observe(item);
      const button = item.querySelector('.tes-motion-toggle');
      if (button) button.addEventListener('click', () => { const paused = item.classList.toggle('is-paused'); button.setAttribute('aria-pressed', String(paused)); button.textContent = paused ? button.dataset.play : button.dataset.pause; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
  preference.addEventListener('change', () => {document.querySelectorAll('[data-tes-motion]').forEach(item=>item.classList.toggle('is-paused',preference.matches));});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tes-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
 function init(root) {
  root.querySelectorAll('.tes-main-nav:not([data-tes-ready])').forEach(nav => {
   nav.dataset.tesReady = 'true';
   const groups = [...nav.querySelectorAll('.tes-nav-group')];
   function close(group) { delete group.dataset.tesHoverOpen; group.classList.remove('tes-nav-open'); group.querySelector('button').setAttribute('aria-expanded','false'); group.querySelector('.tes-nav-panel').inert = true; }
   function open(group, hover=false) {
    if(!group.classList.contains('tes-nav-open')) group.dataset.tesHoverOpen=String(hover);
    groups.forEach(other => { if (other !== group) close(other); });
    const panel = group.querySelector('.tes-nav-panel');
    panel.style.setProperty('--tes-panel-shift','0px');
    group.classList.add('tes-nav-open'); panel.inert = false;
    group.querySelector('button').setAttribute('aria-expanded','true');
    const rect = panel.getBoundingClientRect();
    const shift = rect.left < 20 ? 20-rect.left : rect.right > innerWidth-20 ? innerWidth-20-rect.right : 0;
    panel.style.setProperty('--tes-panel-shift',shift+'px');
   }
   groups.forEach(group => {
    group.querySelector('button').addEventListener('click', () => { if(group.classList.contains('tes-nav-open') && group.dataset.tesHoverOpen!=='true') close(group); else {open(group);delete group.dataset.tesHoverOpen;} });
    group.addEventListener('pointerenter', event => { if(event.pointerType==='mouse' && !document.querySelector('tes-instant-search input:focus')) open(group,true); });
    group.addEventListener('pointerleave', event => { if(event.pointerType==='mouse' && !group.contains(document.activeElement)) close(group); });
    group.addEventListener('focusout', () => { setTimeout(() => { if(!group.contains(document.activeElement)) close(group); },0); });
    group.addEventListener('keydown', event => { if(event.key==='Escape'){event.preventDefault();close(group);group.querySelector('button').focus();} if(event.key==='ArrowDown' && event.target.closest('.tes-nav-trigger')){event.preventDefault();open(group);requestAnimationFrame(()=>group.querySelector('.tes-nav-panel a').focus());} });
   });
   document.addEventListener('click', event => { if(!nav.contains(event.target)) groups.forEach(close); });
   window.addEventListener('resize', () => groups.forEach(close), {passive:true});
  });
 }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true}); else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tes-page-styles"] && !Shopify.designMode) return;
  try {
    (() => {
 const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
 let observer;
 function init(root) {
  if(reduced.matches || !('IntersectionObserver' in window)) return;
  if(!observer) observer = new IntersectionObserver(entries => {
   entries.forEach(entry => { if(entry.isIntersecting){entry.target.classList.add('is-tes-visible');observer.unobserve(entry.target);} });
  },{threshold:0.06});
  root.querySelectorAll('.tes-reveal:not(.is-tes-ready)').forEach(element => {
   if(element.getBoundingClientRect().top < innerHeight) return;
   element.classList.add('is-tes-ready');observer.observe(element);
  });
 }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
 document.addEventListener('shopify:section:load',event=>init(event.target));
 reduced.addEventListener('change',()=>{if(reduced.matches){if(observer)observer.disconnect();document.querySelectorAll('.is-tes-ready').forEach(element=>element.classList.add('is-tes-visible'));}});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tes-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tes-instant-search')) {
 customElements.define('tes-instant-search',class extends HTMLElement {
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.input=this.querySelector('input[type=search]');this.panel=this.querySelector('.tes-search-panel');this.content=this.querySelector('.tes-search-content');this.status=this.querySelector('[role=status]');this.cache=new Map();this.index=-1;this.sequence=0;
   this.input.addEventListener('input',()=>{clearTimeout(this.timer);this.controller?.abort();this.sequence++;this.index=-1;this.input.removeAttribute('aria-activedescendant');this.content.replaceChildren();if(this.input.value.trim().length<2){this.close();return;}this.timer=setTimeout(()=>this.search(),240);});
   this.input.addEventListener('focus',()=>{document.querySelectorAll('.tes-nav-open').forEach(group=>{group.classList.remove('tes-nav-open');group.querySelector('button').setAttribute('aria-expanded','false');group.querySelector('.tes-nav-panel').inert=true;});if(this.input.value.trim().length>=2)this.search();});
   this.addEventListener('focusout',()=>setTimeout(()=>{if(!this.contains(document.activeElement))this.close();},0));
   this.onOutside=e=>{if(!this.contains(e.target))this.close();};document.addEventListener('pointerdown',this.onOutside);
   this.addEventListener('keydown',e=>{if(e.key==='Escape'){e.preventDefault();this.close();return;}const items=[...this.content.querySelectorAll('[role=option]')];if(this.panel.hidden||!items.length)return;if(e.key==='ArrowDown'||e.key==='ArrowUp'){e.preventDefault();this.index=this.index<0?(e.key==='ArrowDown'?0:items.length-1):(this.index+(e.key==='ArrowDown'?1:-1)+items.length)%items.length;items.forEach((x,i)=>x.setAttribute('aria-selected',String(i===this.index)));this.input.setAttribute('aria-activedescendant',items[this.index].id);items[this.index].scrollIntoView({block:'nearest'});}else if(e.key==='Enter'&&this.index>=0&&e.target===this.input){e.preventDefault();items[this.index].querySelector('a').click();}});
  }
  close(){this.panel.hidden=true;this.input.setAttribute('aria-expanded','false');this.input.removeAttribute('aria-activedescendant');this.index=-1;}
  async search(){
   const query=this.input.value.trim();if(query.length<2)return;const seq=++this.sequence;this.controller?.abort();this.controller=new AbortController();this.panel.hidden=false;this.input.setAttribute('aria-expanded','true');this.panel.setAttribute('aria-busy','true');this.status.textContent=this.dataset.loading;
   try{let html=this.cache.get(query);if(!html){const url=new URL(this.dataset.searchUrl,location.origin);url.search=new URLSearchParams({q:query,type:'product','options[prefix]':'last',section_id:'tes-search-results'}).toString();const response=await fetch(url,{signal:this.controller.signal,credentials:'same-origin'});if(!response.ok)throw new Error('Search unavailable');const doc=new DOMParser().parseFromString(await response.text(),'text/html');const results=doc.querySelector('[data-tes-results]');if(!results)throw new Error('Results unavailable');html=results.innerHTML;this.cache.set(query,html);if(this.cache.size>20)this.cache.delete(this.cache.keys().next().value);}if(seq!==this.sequence)return;this.content.innerHTML=html;this.status.textContent=this.content.querySelector('[data-result-summary]')?.textContent||'';this.index=-1;}
   catch(error){if(error.name==='AbortError'||seq!==this.sequence)return;this.content.replaceChildren();this.status.textContent=this.dataset.error;}
   finally{if(seq===this.sequence)this.panel.removeAttribute('aria-busy');}
  }
  disconnectedCallback(){this.controller?.abort();clearTimeout(this.timer);document.removeEventListener('pointerdown',this.onOutside);}
 });
}
  } catch(e) { console.error(e); }
})();

})();
